// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5035":"4c44100b","7589":"79821e3f","8029":"4c44100b"}[chunkId] + ".chunk.css";
};